import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "input", "button"];

  toggleSelector(target) {
    target.classList.toggle('currency-selector__toggle--active')
  }

  initialize() {
    this.buttonTargets.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleSelector(button);
      })
    })

    this.formTargets.forEach((form) => {
      const countries = form.querySelectorAll('a')

      countries.forEach(country => {
        country.addEventListener('click', (e) => {
          e.preventDefault()
          const input = form.querySelector('input[name="country_code"]')
          input.setAttribute('value', country.dataset.value)
          form.submit();
        })
      })
    });
  }
}
